import React, { useState, useEffect } from 'react';
import Icon from './Icon';
import CONFIG from 'core/globals'
import {
  ModalHeader,
  ModalContent,
  Modal,
} from 'semantic-ui-react';

import { MESSAGE_TYPE_GIFT, MODES } from 'core/constants';
import gifts from '../../../assets/gifts.json';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';

const Gift = ({ conversation,giftPrices, store, actions, mode  }) => {
  const { setGiftModalState } = actions.giftModal
  const { giftModalState } = store
  const [showInsufficientModal, setShowInsufficientModal] = useState(
    conversation.giftsBlock
  );
  const [giftCategory, setGiftCategory] = useState('')
  const [giftSelected, setGiftSelected] = useState({})
  const [images, setImages] = useState({});

  useEffect(() => {
    setShowInsufficientModal(conversation.giftsBlock);
  }, [conversation.giftsBlock]);

  function sendGift() {
    conversation.send(giftSelected?.src, MESSAGE_TYPE_GIFT);
    setGiftModalState(false)
  }
  useEffect(() => {
    const giftsImages = Object.keys(gifts?.gifts).map(key => {
      return {
        src: gifts?.gifts[key],
        fileName: key,
        price: giftPrices?.gifts[key] || 1,
      };
    });
    const kinkyImages = Object.keys(gifts?.kinky).map(key => {
      return {
        src: gifts?.kinky[key],
        fileName: key,
        price: giftPrices?.kinky[key] || 1,
      };
    });
    const natureImages = Object.keys(gifts?.nature).map(key => {
      return {
        src: gifts?.nature[key],
        fileName: key,
        price: giftPrices?.nature[key] || 1,
      };
    });
    const romanticImages = Object.keys(gifts?.romantic).map(key => {
      return {
        src: gifts?.romantic[key],
        fileName: key,
        price: giftPrices?.romantic[key] || 1,
      };
    });
    const sweetsImages = Object.keys(gifts?.sweets).map(key => {
      return {
        src: gifts?.sweets[key],
        fileName: key,
        price: giftPrices?.sweets[key] || 1,
      };
    });
    setImages({
      gifts: giftsImages,
      kinky: kinkyImages,
      nature: natureImages,
      romantic: romanticImages,
      sweets: sweetsImages,
    });
  }, []);
  const iconName = mode === MODES.CHAT_LIST ? 'crossClose' : 'closeModal'
  const backIconName = mode === MODES.CHAT_LIST ? 'arrowBack' : 'arrowLeft'
  const backButtonText = mode === MODES.CHAT_LIST ? '' : 'Back'
  const giftIconsMapper = {
    romantic: gifts?.romantic['heart_gift.png'],
    sweets: gifts?.sweets['piece_of_cake.png'],
    nature: gifts?.nature['colibri.png'],
    kinky: gifts?.kinky['leather_wipe.png'],
    gifts: 'https://images.thedatingmessenger.com/gifts/coins_icon.png',
  }
  return (
    <div className="gift-wrapper">
      <Modal
        onClose={() => {
          setGiftSelected({});
          setGiftModalState(false)
        }}
        onOpen={() => {
          setGiftSelected({});
          setGiftCategory('');
          setGiftModalState(true)
        }}
        open={giftModalState}
        className={classNames({
          'gift-modal': true,
          [mode + '-mode']: mode,
        })}
        trigger={
          <a className="gift-icon-button">
            <Icon iconName="gift"/>
          </a>
        }
      >
        {giftCategory == '' ? (
          <ModalHeader>
            <GiftHeader
              setGiftSelected={setGiftSelected}
              setShowGiftModal={arg => setGiftModalState(arg)}
              setGiftCategory={setGiftCategory}
              conversation={conversation}
              mode={mode}
            />
          </ModalHeader>
        ) : (
          <ModalHeader className="gift-mobile-header">
            <GiftHeader
              setGiftSelected={setGiftSelected}
              setShowGiftModal={arg => setGiftModalState(arg)}
              setGiftCategory={setGiftCategory}
              className="gift-toggle-header"
              conversation={conversation}
              mode={mode}
            />
            <div className="gift-modal-header-gifts">
              <div
                className="gift-modal-back"
                onClick={() => setGiftCategory('')}
              >
                <Icon iconName={backIconName} className="gift-back-arrow"/>
                {backButtonText}
              </div>
              <div className="gift-modal-gift-title">
                {mode === MODES.CHAT_LIST
                  && <img className="gift-title-image" src={giftIconsMapper[giftCategory]}></img>
                }
                {giftCategory?.charAt(0).toUpperCase() + giftCategory?.slice(1)}
              </div>
              <div className="gift-close">
                <Icon
                  iconName={iconName}
                  onClick={() => {
                    setGiftModalState(false)
                    setGiftCategory('');
                  }}
                />
              </div>
            </div>
          </ModalHeader>
        )}
        <ModalContent className="gift-modal-content">
          {giftCategory == '' && images?.kinky ? (
            <GiftsContent
              giftCategory={giftCategory}
              setGiftCategory={setGiftCategory}
              images={images}
              setGiftSelected={setGiftSelected}
              giftSelected={giftSelected}
            />
          ) : (
            <>
              <div className="gift-modal-gifts-desktop">
                <GiftsContent
                  giftCategory={giftCategory}
                  setGiftCategory={setGiftCategory}
                  images={images}
                  setGiftSelected={setGiftSelected}
                  giftSelected={giftSelected}
                />
              </div>
              <div className="gift-modal-gifts">
                {images && (
                  <div className="gifts-container">
                    {images[giftCategory]?.map(img => {
                      const { src, fileName, price } = img;
                      return (
                        <div
                          key={src}
                          className={`${
                            giftSelected?.fileName == fileName &&
                            'gift-selected'
                          } gift-modal-gift`}
                          onClick={() => setGiftSelected(img)}
                        >
                          <img src={src}/>
                          {!CONFIG.hideCreditsCostForMobile &&
                            <div className="gift-price">
                              {price}{' '}
                              <img
                                className="gift-cost-icon"
                                src="https://images.thedatingmessenger.com/gifts/coins_icon.png"
                                width={18}
                                height={18}
                              />
                            </div>
                          }
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </>
          )}
        </ModalContent>
        {Object.keys(giftSelected).length !== 0 && (
          <div className="gift-confirmation">
            <div className="gift-close">
              <Icon
                iconName={iconName}
                onClick={() => {
                  setGiftSelected({});
                }}
              />
            </div>
            <div className="gift-modal-gift">
              <img src={giftSelected?.src}/>
              {!CONFIG.hideCreditsCostForMobile &&
                <div className="gift-price">
                  {giftSelected?.price}
                  <img
                    className="gift-cost-icon"
                    src="https://images.thedatingmessenger.com/gifts/coins_icon.png"
                    width={18}
                    height={18}
                  />
                </div>
              }
            </div>
            <div className="gift-confirmation-btn" onClick={() => sendGift()}>
              SEND A GIFT
            </div>
          </div>
        )}
      </Modal>
      <Modal
        open={showInsufficientModal}
        className="insufficient-modal"
        onClose={() => conversation.toggleGiftBlock(false)}
      >
        <ModalHeader className="insufficient-modal-header">
          <div className="insufficient-modal-close">
            <Icon
              iconName="closeModal"
              onClick={() => {
                conversation.toggleGiftBlock(false);
              }}
            />
          </div>
        </ModalHeader>
        <ModalContent className="insufficient-modal-content">
          <div className="title">
            You do not have enough credits to send this gift!
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default inject('store', 'actions')(observer(Gift))

function GiftsContent({
  giftCategory,
  setGiftCategory,
  images,
  setGiftSelected,
  giftSelected,
}) {
  return (
    <div className="gift-category-container">
      <div className="gift-modal-categories">
        <div
          className={`${
            giftCategory == '' || giftCategory == 'romantic'
              ? 'gift-default-selection'
              : ''
          } gift-modal-selection`}
          onClick={() => setGiftCategory('romantic')}
        >
          <div className="gift-modal-icon">
            <img
              width={30}
              height={30}
              src={gifts?.romantic['heart_gift.png']}
            />
          </div>
          <div>Romantic</div>
        </div>
        <div
          className={`${
            giftCategory == 'sweets' ? 'gift-default-selection' : ''
          } gift-modal-selection`}
          onClick={() => setGiftCategory('sweets')}
        >
          <div className="gift-modal-icon">
            <img
              width={30}
              height={30}
              src={gifts?.sweets['piece_of_cake.png']}
            />
          </div>
          <div>Sweets</div>
        </div>
        <div
          className={`${
            giftCategory == 'nature' ? 'gift-default-selection' : ''
          } gift-modal-selection`}
          onClick={() => setGiftCategory('nature')}
        >
          <div className="gift-modal-icon">
            <img width={30} height={30} src={gifts?.nature['colibri.png']}/>
          </div>
          <div>Nature</div>
        </div>
        <div
          className={`${
            giftCategory == 'kinky' ? 'gift-default-selection' : ''
          } gift-modal-selection`}
          onClick={() => setGiftCategory('kinky')}
        >
          <div className="gift-modal-icon">
            <img
              width={30}
              height={30}
              src={gifts?.kinky['leather_wipe.png']}
            />
          </div>
          <div>Kinky</div>
        </div>
        <div
          className={`${
            giftCategory == 'gifts' ? 'gift-default-selection' : ''
          } gift-modal-selection`}
          onClick={() => setGiftCategory('gifts')}
        >
          <div className="gift-modal-icon">
            <img width={30} height={30} src="https://images.thedatingmessenger.com/gifts/coins_icon.png"/>
          </div>
          <div>Gifts</div>
        </div>
      </div>
      <div className="gifts-container-desktop">
        <>
          {images[giftCategory == '' ? 'romantic' : giftCategory]?.map(
            img => {
              const { src, fileName, price } = img;
              return (
                <div
                  key={src}
                  className={`${
                    giftSelected?.fileName == fileName && 'gift-selected'
                  } gift-modal-gift`}
                  onClick={() => setGiftSelected(img)}
                >
                  <img src={src}/>
                  {!CONFIG.hideCreditsCostForMobile &&
                    <div className="gift-price">
                      {price}{' '}
                      <img
                        className="gift-cost-icon"
                        src="https://images.thedatingmessenger.com/gifts/coins_icon.png"
                        width={18}
                        height={18}
                      />
                    </div>
                  }
                </div>
              );
            }
          )}
        </>
      </div>
    </div>
  );
}

function GiftHeader({
  setGiftSelected,
  setShowGiftModal,
  setGiftCategory,
  className,
  conversation,
  mode,
}) {
  const iconName = mode === MODES.CHAT_LIST ? 'crossClose' : 'closeModal'
  return (
    <div className={`${className} gift-modal-header`}>
      <div className="gift-close">
        <Icon
          iconName={iconName}
          onClick={() => {
            setGiftSelected({});
            setShowGiftModal(false);
            setGiftCategory('');
          }}
        />
      </div>
      <div className="send-gift-title">Send {conversation.otherUserProfile.username} a Virtual Gift!</div>
    </div>
  );
}
